"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/@material-ui/styles/createStyles/createStyles.js
// module id = 371
// module chunks = 0